import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Camera } from '../../scan-numberplate.model';
import { AbstractWidgetComponent, ContextChange, DialogService, HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-scan-numberplate-dialog',
  templateUrl: './scan-numberplate-dialog.component.html',
  styleUrls: ['./scan-numberplate-dialog.component.scss']
})
export class ScanNumberplateDialogComponent extends AbstractWidgetComponent implements OnInit {

  cameras = new Array<Camera>();

  selected: Camera;

  constructor(
    private httpService: HttpService,
    private dialogService: DialogService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {

    this.httpService.postWithContext<Array<Camera>>(environment.scanNumberplateEndpoint + '/getAllCameras', {}).subscribe(
      cameras => {
        const result = new Array<Camera>();
        for (const camera of cameras) {
          result.push(new Camera(camera));
        }
        this.cameras = result;
      }
    );

  }

  onContextChange(contextChange: ContextChange) {
  }


  onSetElementAndContext() {
  }

  selectCamera(camera: Camera) {
    this.selected = camera;
  }

  scanNumberplate() {
        this.httpService.postWithContext<Array<Camera>>(environment.scanNumberplateEndpoint + '/scanNumberplate', { cameraId: this.selected.id }).subscribe(
          response => {

          }
        );
  }
}
